var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcManagementOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B6D0D2",
  d: "M6.883.05A9.36 9.36 0 0 0 .05 6.88C-.23 8.03.7 9.12 1.88 9.12h5.373c1.03 0 1.87-.84 1.87-1.87V1.88c0-1.18-1.09-2.11-2.24-1.83"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E4EFF0",
  d: "M10.664 3.417v4.81c0 1.6-.84 2.43-1.871 2.43H3.42c-1.18 0-2.11 1.1-1.83 2.25 1.03 4.15 4.831 7.21 9.333 7.09 4.872-.13 8.943-4.2 9.073-9.07a9.336 9.336 0 0 0-7.093-9.33c-1.15-.28-2.25.64-2.25 1.83z"
})));
export default SvgIcManagementOff;